module.exports = __webpack_public_path__ + "static/img/suogou.80490a24.png";